module.exports = __webpack_public_path__ + "assets/img/noWL.7610812b.svg";